<template>
  <!-- 精准客户 -->
  <div class="viewContainer">
    <!-- 搜索/查询 -->
    <div class="main_container">
      <div class="fuji">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao" />
      </div>
      <el-collapse-transition>
        <el-form class="findform">
          <el-form-item label="状态：" style="display:flex;width:30%">
            <el-select v-model="ztid" placeholder="请选择" style="width:80%" @change="handleDp">
              <el-option v-for="(item, index) in zhuangtai" :key="index" :value="item.Id" :label="item.Name" />
            </el-select>
          </el-form-item>
          <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
        </el-form>
      </el-collapse-transition>
    </div>
    <!-- 精准客户列表 -->
    <div class="main_container">
      <section class="model_section" style="display: flex;justify-content: space-between;">
        <div>
          <p class="model_top_title">精准客户</p>
        </div>
      </section>
      <div class="table_container">
        <el-table :data="xsjlList" stripe border>
          <el-table-column label="序号" align="center" width="60">
            <template scope="scope"> <span>{{ scope.$index + 1 }}</span> </template>
          </el-table-column>
          <el-table-column label="用户隐私号" align="center">
            <template scope="scope">
              <span :title="scope.row.virtualnumber"> {{ scope.row.virtualnumber }}</span>
            </template>
          </el-table-column>
          <el-table-column label="拨打时间" align="center">
            <template scope="scope">
              <span :title="scope.row.calltime"> {{ scope.row.calltime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="客户价格" align="center">
            <template scope="scope">
              <span :title="scope.row.price"> {{ scope.row.price }} 元</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template scope="scope">
              <span :title="scope.row.statusname"> {{ scope.row.statusname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="260">
            <template scope="scope">
              <span class="handle" @click="showAdd(scope.row)"> <i class="el-icon-view" /> 查看 </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="currentChangeOne" :page-size="10" :total="totalOne"
          :current-page="pageIndexOne" style="float:right;margin: 10px 0;" />
      </div>
    </div>

    <!-- 抽屉详情 size="50%" -->
    <el-drawer :visible.sync="isSeePopup" :show-close=false>
      <template v-slot:title>
        <ul class="drawer_title">
          <li>订单详情</li>
        </ul>
      </template>
      <div class="drawer_div">
        <ul class="drawer_ul">
          <li>
            <span class="watch_first">用户隐私号：</span>
            <span>{{ formDetails.virtualnumber }}</span>
          </li>
          <li>
            <span class="watch_first">拨打时间：</span>
            <span>{{ formDetails.calltime }}</span>
          </li>
          <li>
            <span class="watch_first">客户价格：</span>
            <span>{{ formDetails.price }}元</span>
          </li>
          <li>
            <span class="watch_first">状态：</span>
            <span>{{ formDetails.status == 1 ? '已购买' : formDetails.status == 2 ? '退款审核中' : formDetails.status == 3 ?
              '已退款' : '审核不通过' }}</span>
          </li>
          <li v-if="formDetails.status != 1">
            <span class="watch_first">退款原因：</span>
            <span>{{ formDetails.reason }}</span>
          </li>
          <li v-if="formDetails.status == 3 || formDetails.status == 4">
            <span class="watch_first">审核原因：</span>
            <span>{{ formDetails.auditreason }}</span>
          </li>
          <li>
            <span class="watch_first">通话录音：</span>
            <audio :src="formDetails.rediourl" controls="controls" style="width: 90%;height: 35px;margin: 5px 0;" />
          </li>
        </ul>
        <div class="drawer_foot">
          <el-button type="danger" @click="cancelForm">关 闭</el-button>
          <el-button type="danger" @click="refundFun(formDetails.recordid)"
            v-if="formDetails.canrefund == 1">申诉退款</el-button>
        </div>
      </div>
    </el-drawer>


    <!-- 请选择店铺弹框 -->
    <el-dialog :center="true" title="请选择店铺" :visible.sync="dialogVisibleadd" width="25%">
      <el-form class="findform">
        <el-form-item label="店铺名称：" style="display:flex;">
          <el-select v-model="bbid" filterable placeholder="请选择店铺" @change="changeDianpu">
            <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="gonext()">确定</el-button>
      </div>
    </el-dialog>


  </div>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { precisioncustomer, precisioncustomerDet, precisioncustomerrefund, } from "../../api/shopWindow";
import { getEffectiveBrandBusiness, } from "../../api/activityFormList";
export default {
  name: "PrecisionCustomerList",  //精准客户
  mixins: [alertTrends],
  data() {
    return {

      zhuangtai: [
        {Id: 0,
        Name: '全部'},
        {Id: 1,
          Name: '已购买'},
        {Id: 2,
          Name: '申请退款'},
        {Id: 3,
          Name: '已退款'},
        {Id: 4,
          Name: '审核失败'},
      ],


      isSeePopup: false, //查看
      formDetails: [],//详情

      xsjlList: [],
      pageIndexOne: 1,
      totalOne: 0,


      
      recordurl: '', // 录音URL
      callrecords: [], // 录音列表
      api2cs: localStorage.api2cs,

      dialogVisibleadd: false,
      bbid: '',  // 店铺id
      bbType: '', // 店铺类型
      options1: [],

      ztid: 0,
    }
  },
  methods: {
    // 套餐包列表
    init() {
      let obj = {
        shopid: this.bbid,
        status: this.ztid,
        page: this.pageIndexOne, // 页码
        size: 10, // 条数
      }
      precisioncustomer(obj).then(data => {
        if (data.resultCode == 1) {
          this.xsjlList = data.resultObj.list;
          this.totalOne = data.resultObj.totalcount;
        } else {
          this.xsjlList = [];
          this.totalOne = 0
        }
      })
    },
    // 分页
    currentChangeOne(val) {
      this.pageIndexOne = val;
      this.init()
    },

    fnReset() {
      this.ztid = 0;
      this.pageIndexOne = 1;
      this.init()
    },

    // 查询
    onSubmit() {
      this.init()
    },

    // handleDp(row){
    //   this.init()
    // },

    showAdd(row) {
      this.isSeePopup = true;
      let recordid = row.recordid;
      console.log(recordid)
      this.precisioncustomerDetFun(recordid);//获取套餐包详情

    },
    
    //获取套餐包详情
    precisioncustomerDetFun(recordid) {
      let obj = {
        shopid: this.bbid,
        recordid: recordid,
      }
      precisioncustomerDet(obj).then(data => {
        if (data.resultCode == 1) {
          this.formDetails = data.resultObj;
        } else {
          this.formDetails = [];
        }
      })
    },
    // 申诉退款
    refundFun(recordid){
      this.$prompt('请输入退款原因(200字以内)', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^\S.{0,199}$/,
        inputErrorMessage: '请输入退款原因，字数不能超过200字'
      }).then(({ value }) => {
        let obj = {
          shopid: this.bbid,
          recordid: recordid,
          reason: value
        }
        precisioncustomerrefund(obj).then(data => {
          if (data.resultCode == 1) {
            this.$swal({
              type: "success",
              text: "操作成功"
            });
            this.isSeePopup = false;
            this.init()
          }
        })
        
      }).catch(() => {
        
      });
      
    },
    cancelForm() {
      this.isSeePopup = false
    },
    // 套餐包明细
    handleSelectChange() {
      const newProductItems = [];
      this.selectedProductIds.forEach(productId => {
        // 从 producttype 中找到对应的产品对象
        const product = this.producttype.find(item => item.productid === productId);
        if (!product) return;

        // 保留已有输入值
        const existingItem = this.productItems.find(
          item => item.product.productid === productId
        );
        if (existingItem) {
          newProductItems.push(existingItem);
        } else {
          // 根据 producttype 设置初始数量
          let num = "1"; // producttype=2 默认 1
          if (product.producttype === 1) {
            num = ""; // producttype=1 初始为空
          }
          newProductItems.push({ product, num });
        }
      });
      this.productItems = newProductItems;
    },

    /**
     * 处理输入框内容：过滤非数字，根据产品类型设置规则
     * @param {Object} item - productItems 中的项（包含 product 和 quantity）
     * @param {string} val - 输入框原始值
     */
    handleQuantityInput(item, val) {
      const value = val.replace(/\D/g, "");
      if (item.product.producttype === 1) {
        item.num = value; // 允许空值
      } else if (item.product.producttype === 2) {
        item.num = value || "1"; // 空值自动设为 1
      }
    },
    
    // 限制日期
    disableBeforeToday(date){
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const isDisabled = date.getTime() <= today.getTime();
      return isDisabled;
    },

    // 初始化弹框
    tankuang() {
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
      };
      getEffectiveBrandBusiness(addParams).then(data => {
        if (data.resultCode == 1) {
          if (data.resultObj.length > 1) {
            this.dialogVisibleadd = true;
            this.options1 = data.resultObj;
          } else {
            this.dialogVisibleadd = false;
            this.bbid = data.resultObj[0].id; // 店铺id
            this.bbType = data.resultObj[0].bbType; // 店铺类型
            this.gonext();
          }
        } else {
          this.showAlert('请先在店铺信息功能中创建自己店铺');
          return false;
        }
      })
    },
    changeDianpu(id) {
      let the = this.options1.find(item => item.id === id);
      // console.log(the,'获取店铺信息')
      this.bbid = the.id; // 店铺id
      this.bbType = the.bbType; // 店铺类型
    },
    gonext() {
      if (this.bbid == "") {
        this.showAlert('请选择店铺名称');
        return false
      }
      this.init(1); // 查询列表
      this.dialogVisibleadd = false;
    },


  },
  mounted() {

    // let bbid = this.$route.query.bbid;
    this.bbid = this.$route.params.bbid ? this.$route.params.bbid : '';
    this.bbType = this.$route.params.bbType ? this.$route.params.bbType : '';
    this.tabPosition = this.$route.params.type ? this.$route.params.type : '1';
    // this.bbid = localStorage.bbid;
    if (this.bbid === '') {
      this.tankuang();
    } else {
      this.init(); // 初始化查询列表
    }
    
  },
  watch: {
    
  }
}
</script>
<style scoped>
.drawer_title {
  padding-left: 0;
  display: flex;
  justify-content: space-between;
}

.drawer_title>li:first-child {
  font-size: 18px;
  font-weight: bolder;
  color: #333;
}

.drawer_div {
  width: 96%;
  margin: 0 auto;
}

.drawer_ul:first-child {
  /* border-bottom: 2px solid #eee; */
  padding-bottom: 10px;
  margin-bottom: 5px;
}

.drawer_ul>li {
  line-height: 40px;
  font-size: 16px;
}

.drawer_ul>li>span {
  font-size: 15px;
}

.drawer_ul>li>span>img {
  width: 66px;
  height: 66px;
  margin-left: 10px;
  margin-bottom: 10px;
}


/* 外层布局：并排显示多选框和输入区 */
.package-detail-layout {
  display: flex;
  align-items: flex-start;
  /* 垂直顶部对齐，避免多选框和输入区高度差异导致错位 */
  gap: 24px;
  /* 多选框与输入区的间距 */
}

/* 输入区：垂直排列每个输入项 */
.package-input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  /* 输入项之间的间距 */
}

/* 单个输入项：名称与输入框横向对齐 */
.input-row {
  display: flex;
  align-items: center;
  gap: 12px;
  /* 名称与输入框的间距 */
}

/* 产品名称：固定宽度 + 右对齐，确保输入框整齐 */
.product-name {
  min-width: 80px;
  text-align: right;
}

</style>


// WEBPACK FOOTER //
// PrecisionCustomerList.vue?cafb8526